import { makeStyles } from '@rbx/ui';

const useCodeSampleContainerStyles = makeStyles()(() => ({
  title: {
    marginBottom: 24,
  },
  codeBlock: {
    fontSize: '14px',
  },
}));

export default useCodeSampleContainerStyles;
